// Mapea el tipo de documento de los selectores al ID del catálogo
// tbl_vtf_tipodocumento (1 RUC, 2 DNI, 3 Carné de Extranjería, 4 Pasaporte).
// Cada formulario usa un literal distinto ("CARNET EXT.", "CE",
// "Carnet de Extranjería"...), por lo que se normaliza tildes/mayúsculas:
// un valor no reconocido devolvía undefined y el backend lo guardaba como RUC.
export const typeDoc = (typeD) => {
  if (!typeD) return undefined;
  const normalized = String(typeD)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();
  if (normalized === "RUC") return 1;
  if (normalized === "DNI") return 2;
  if (normalized === "CE" || normalized.startsWith("CARN")) return 3;
  if (normalized === "PASAPORTE" || normalized === "PASSPORT") return 4;
  return undefined;
};
